'use client';
import { gql } from '@apollo/client';
import { useFeatureCookie } from '@mnd-frontend/hooks';
import { useTranslation } from '@mnd-frontend/ui/publish/contexts';
import { SPACING_1 } from '@mnd-frontend/ui/shared/tokens';
import styled from 'styled-components';
import { useAdminPanelLinkQuery } from '../../../../generated/hooks';

gql`
  query AdminPanelLink($pressroomId: ID!) {
    pressroom(id: $pressroomId) {
      source {
        id
      }
    }
  }
`;

const Wrapper = styled.div`
  padding: ${SPACING_1};
  margin: ${SPACING_1};
`;

export const AdminPanelLink = ({ pressroomId }: { pressroomId: string }) => {
  const { t } = useTranslation();
  const enableAdminPanelLink = useFeatureCookie('admin_panel_link');
  const { data } = useAdminPanelLinkQuery({
    variables: {
      pressroomId,
    },
  });

  if (!enableAdminPanelLink) return null;

  const sourceId = data?.pressroom?.source?.id;
  if (!sourceId) return null;

  return (
    <Wrapper>
      <a
        href={`https://www.mynewsdesk.com/admin/sources/${sourceId}/pressrooms/${pressroomId}/edit`}
        target="_blank"
        rel="noreferrer"
      >
        {t('open_admin_panel')}
      </a>
    </Wrapper>
  );
};
